const digest = 'c319bc6d52f68313bebf144869423354fe955705f91a9f13830373dbfaa9ff5a';
const css = `._quitModal_jbh5z_1{width:320px}._cursorPointer_jbh5z_5{cursor:pointer}`;
(function() {
  if (global.BROWSER && !document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
export default { 'quitModal': '_quitModal_jbh5z_1', 'cursorPointer': '_cursorPointer_jbh5z_5' };
export const quitModal = '_quitModal_jbh5z_1';
export const cursorPointer = '_cursorPointer_jbh5z_5';
export { css, digest };